/**
 * @generated SignedSource<<4cdd863a27d7d6f74c004beed8a0d6ef>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspacePublishButtonFragment$data = {
  readonly baseVersions: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly publishedAt: DateTime | null | undefined;
      readonly version: Semver;
    }>;
  };
  readonly id: string;
  readonly viewerCanCreateVersion: boolean;
  readonly " $fragmentType": "WorkspacePublishButtonFragment";
};
export type WorkspacePublishButtonFragment$key = {
  readonly " $data"?: WorkspacePublishButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspacePublishButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspacePublishButtonFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": "viewerCanCreateVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_WORKSPACE_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_WORKSPACE_VERSION\")"
    },
    {
      "alias": "baseVersions",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "WorkspaceVersionConnection",
      "kind": "LinkedField",
      "name": "versions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkspaceVersion",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "version",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publishedAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "versions(first:50)"
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "78cf10a17a2776c0b5942d7f15bb5d16";

export default node;
